import { all, fork } from 'redux-saga/effects';
import languages from './languages';

export default function* events() {
  yield all([fork(languages)]);
}
